module.exports = __webpack_public_path__ + "assets/qw_close.74d865b.png";